import axios from 'axios';

// Changes all of an object's keys to camel case
const sanitise = (obj) => {
  const newObj = {};

  if (obj instanceof Array) {
    return obj.map((value) => {
      if (typeof value === 'object') {
        value = sanitise(value);
      }
      return value;
    });
  } else {
    for (const origKey in obj) {
      if (obj.hasOwnProperty(origKey)) {
        const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        let value = obj[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = sanitise(value);
        }
        newObj[newKey] = value;
      }
    }
  }

  return newObj;
};

const instance = axios.create();

// Add the access token to each request
instance.interceptors.request.use((axiosConfig) => {
  const microserviceToken = localStorage.getItem('whizeo-internal-token');
  if (microserviceToken) {
    axiosConfig.headers['x-access-token'] = microserviceToken;
  }
  return axiosConfig;
});

// All requests are sanitised to camel case
instance.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'application/json; charset=utf-8') {
    response.data = sanitise(response.data);
  }
  return response;
});

export default instance;
